import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import api from 'services/api';
import {
  Flex,
  HStack,
  SimpleGrid,
  VStack,
  Box,
  Button,
} from '@chakra-ui/react';
import FormGroup from 'components/form/FormGroup';
import FormInput from 'components/form/FormInput';

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { formatDate } from '../../utils/formataData';

import BoxContent from '../../components/BoxContent';
import { Select } from '../../components/form/Select';

import TituloPagina from '../../components/TituloPagina';
import { useAuth } from '../../contexts/auth';
import { useProcesso } from '../../contexts/processo';

interface IProcesso {
  id_processo: number;
  nome: string;
  situacao: string;
  criado_por?: string;
  criado_em?: string;
  atualizado_em?: string;
  atualizado_por?: string;
}

const ShowProcessoIrso: React.FC = () => {
  const { user } = useAuth();
  const { idProcesso } = useProcesso();
  const history = useHistory();

  const [processo, setprocesso] = useState<IProcesso>();

  const optionsSitProcessodeIrso = [
    { value: '1', label: 'Ativa' },
    { value: '0', label: 'Inativa' },
  ];

  const schema = Yup.object().shape({
    nomeProcesso: Yup.string()
      .required('Informe o nome da Processo da DRSO')
      .min(3, 'Nome digitado muito pequeno'),
  });

  const { errors, handleSubmit, register } = useForm<IProcesso>({
    resolver: yupResolver(schema),
    defaultValues: {
      id_processo: processo?.id_processo,
      nome: processo?.nome,
      situacao: processo?.situacao,
      criado_por: processo?.criado_por,
      criado_em: processo?.criado_em,
      atualizado_em: processo?.atualizado_em,
      atualizado_por: processo?.atualizado_por,
    },
  });

  const handleSair = (): void => {
    history.push('/listarprocesso');
  };

  useEffect(() => {
    const loadCounts = async (): Promise<void> => {
      try {
        const processoGet = await api.get(`/processo/${idProcesso}`);
        setprocesso(processoGet.data);
      } catch (error) {
        console.log('Ocorreu um erro');
      }
    };
    loadCounts();
  }, [user]);
  return (
    <>
      {processo && (
        <>
          <TituloPagina title={`Processo de DRSO - ${processo.nome}`} />
          <BoxContent>
            <Box
              as="form"
              flex="1"
              onSubmit={handleSubmit(() => console.log('teste'))}
            >
              <VStack spacing="4">
                <SimpleGrid minChildWidth="300px" spacing={['2', '4']} w="100%">
                  <FormGroup name="Nome">
                    <FormInput
                      name="nomeProcesso"
                      disabled
                      defaultValue={processo.nome}
                      register={register}
                    />
                  </FormGroup>
                  <FormGroup name="Situação">
                    <Select
                      placeholder="Selecione uma Opção"
                      isDisabled
                      name="situacaoProcesso"
                      defaultValue={processo.situacao}
                      ref={register}
                      options={optionsSitProcessodeIrso}
                    />
                  </FormGroup>
                  <FormGroup name="Cadastrado Por">
                    <FormInput
                      name="criadoPor"
                      disabled
                      defaultValue={processo.criado_por}
                      register={register}
                    />
                  </FormGroup>

                  <FormGroup name="Registro Criado Em">
                    <FormInput
                      name="cadastro"
                      disabled
                      defaultValue={formatDate(
                        String(processo.criado_em),
                        'dd/MM/yyyy',
                      )}
                      register={register}
                    />
                  </FormGroup>
                </SimpleGrid>
                <Flex mt="8" justify="flex-end">
                  <HStack spacing="4">
                    <Button as="a" colorScheme="red" onClick={handleSair}>
                      Voltar
                    </Button>
                  </HStack>
                </Flex>
              </VStack>
            </Box>
          </BoxContent>
        </>
      )}
    </>
  );
};

export default ShowProcessoIrso;
